import { useState } from "react";

import styled from "styled-components/macro";

import { AdditionalCardSettings } from "Payments/AddPaymentMethod";
import { usePaymentMethodState } from "Payments/AddPaymentMethod";
import { useBankProvider } from "Payments/globalPaymentsStateHooks";
import { AnimatePresence, motion } from "framer-motion";

import { useFnrModalState } from "UI/FnrModal";

import { usePaymentTypeVerbiage } from "Utilities/Hooks/usePaymentTypeVerbiage";

import CardErrorMessages from "./CardErrors";
import SubmitButtons from "./SubmitButtons";

export default function AdditionalSettings({
  inputErrors,
  setInputErrors,
  setShouldClearDisplayMessages,
  hasMobilePhone,
  sharableWith,
  networkName,
}) {
  const { mustSaveCard, isAlreadyExisting, paymentType } =
    usePaymentMethodState();
  const { providerIsStax } = useBankProvider();

  const [showAdditionalSettings, setShowAdditionalSettings] =
    useState(isAlreadyExisting);

  const fundSettingPaymentType =
    window.data?.paymentPageData?.fund?.paymentPageSettings?.paymentType ||
    null;
  const verbiage = usePaymentTypeVerbiage(fundSettingPaymentType);

  const { hasAnimatedIn } = useFnrModalState();

  return (
    <AdditionalSettingsAndSaveContainer
      initial={{ y: -80, opacity: 0, scale: 0.9 }}
      animate={
        hasAnimatedIn && {
          y: 0,
          opacity: 1,
          scale: 1,
          transition: { delay: 0.12 },
        }
      }
    >
      <CardErrorMessages inputErrors={inputErrors} />
      <AdditionalSettingsContainer>
        <AnimatePresence initial={!isAlreadyExisting}>
          {showAdditionalSettings && (
            <motion.div
              key="settings"
              initial={{
                height: 0,
                opacity: 0,
                scale: mustSaveCard || isAlreadyExisting ? 0.8 : 1,
              }}
              animate={{
                opacity: 1,
                height: "auto",
                scale: 1,
                transition: { delay: 0.15 },
              }}
            >
              <AdditionalCardSettings
                hasMobilePhone={hasMobilePhone}
                sharableWith={sharableWith}
                networkName={networkName}
                verbiage={verbiage}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </AdditionalSettingsContainer>
      <SubmitButtons
        showAdditionalSettings={showAdditionalSettings}
        setShowAdditionalSettings={setShowAdditionalSettings}
        setInputErrors={setInputErrors}
        setShouldClearDisplayMessages={setShouldClearDisplayMessages}
        bypassCcIsReady={paymentType === "bank"}
      />
    </AdditionalSettingsAndSaveContainer>
  );
}

const AdditionalSettingsAndSaveContainer = styled(motion.div)`
  background: linear-gradient(to bottom right, #fff, #eceff0);
  margin: 0 8px;
  padding: 8px;
  border-radius: 12px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  overflow: auto;

  /* CHROME (and anywhere backdrop-filter is supported) */
  @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
    background: linear-gradient(
      to bottom right,
      rgba(255, 255, 255, 0.8),
      rgba(236, 239, 240, 0.8)
    );
    backdrop-filter: blur(12px) saturate(2);
    -webkit-backdrop-filter: blur(12px) saturate(2);
  }
`;

const AdditionalSettingsContainer = styled.div`
  position: relative;
`;
